import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./motion";

const SHOTS = [
  ["/img/hero.jpg", "Gloss black coupe"], ["/img/beading.jpg", "Ceramic water beading"], ["/img/foam.jpg", "Snow foam pre-wash"],
  ["/img/supercar.jpg", "Supercar under studio light"], ["/img/tint.jpg", "Window tint install"], ["/img/foambay.jpg", "Foam bath in the bay"],
];

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["4%", "-38%"]);
  return (
    <section ref={ref} data-testid="gallery-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 mb-12 flex items-end justify-between gap-6">
        <Reveal><p className="eyebrow mb-4">05 — The finish</p><h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] chrome-text">Built for<br />the reflection.</h2></Reveal>
      </div>
      <motion.div style={{ x }} className="hidden md:flex gap-4 pl-10 w-max">
        {SHOTS.map(([src, alt], i) => (
          <figure key={src} className={`group relative overflow-hidden shrink-0 ${i % 2 ? "w-[30vw] h-[52vh] mt-16" : "w-[38vw] h-[60vh]"}`}>
            <img src={src} alt={alt} className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
            <figcaption className="absolute bottom-4 left-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white/80 bg-black/50 px-2 py-1">{alt}</figcaption>
          </figure>
        ))}
      </motion.div>
      <div className="md:hidden flex gap-3 overflow-x-auto no-scrollbar snap-x snap-mandatory px-5">
        {SHOTS.map(([src, alt]) => (
          <figure key={src} className="relative shrink-0 w-[80vw] aspect-[4/5] overflow-hidden snap-center">
            <img src={src} alt={alt} className="h-full w-full object-cover" />
          </figure>
        ))}
      </div>
    </section>
  );
};
